import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { IconButton, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MyPage2 from '../../mypage/MyPage2';

const styles = (theme) => ({
  dialogRoot: {
    minHeight: '80vh',
    maxHeight: '90vh',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100vh',
      margin: '0px',
    },
  },
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
    fontSize: '20px',
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingBottom: '16px',
    // borderBottom: '2px solid #025a3c',
  },
  dialogTitleContent: {
    fontWeight: 'bold',
    margin: '0 15px',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6em',
      fontSize: '16px',
    },
  },
  container: {
    maxWidth: 600,
    flexGrow: 1,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  bottomMargin: {
    marginBottom: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  dialogActions: {
    display: 'none',
    borderTop: '1px solid #ebebeb',
    margin: '0 24px',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
});

class AttendCheckDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      select: 0,
      imgArray: ['/images/ksic2021/pag_01.png', '/images/pag_02.jpg', '/images/pag_03.jpg'],
    };
  }

  render() {
    const { classes, open, onClose } = this.props;
    // eslint-disable-next-line
    const onChangeDate = (value) => {
      this.setState({ select: value });
    };

    return (
      <Dialog
        fullWidth
        maxWidth={this.state.matches ? 'xs' : 'lg'}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        // disableBackdropClick={disableBackdrop}
        // disableEscapeKeyDown={disableBackdrop}
      >
        <DialogTitle className={classes.dialogTitle} onClose={onClose}>
          <Grid container justifyContent="center" alignContent="center">
            <Grid container item xs={1} />
            <Grid container justifyContent="center" alignContent="center" item xs={10}>
              {/* <Grid style={{ backgroundColor: this.props.theme.palette.primary.main, borderRadius: '30px', padding: '8px 8vw' }}>
                <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '22px' }}>My Page</Typography>
              </Grid> */}
            </Grid>
            <Grid container justifyContent="center" alignContent="center" item xs={1}>
              <IconButton
                onClick={onClose}
                className={classes.closeBtn}
                // style={{ position: 'absolute' }}
              >
                <CloseIcon size={40} />
              </IconButton>
            </Grid>
          </Grid>

          {/* <div className={classes.dialogTitleContent}>My Page</div>
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton> */}
        </DialogTitle>
        <DialogContent style={this.state.matches ? { padding: 8 } : { padding: '0 30px 60px 30px' }}>
          <React.Fragment>
            <MyPage2 />
          </React.Fragment>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AttendCheckDialog);
